import NumberedCard from './NumberedCard';

export default NumberedCard;
